import { Route, Routes } from "react-router-dom";
import MapScreen from "../pages/Map/MapScreen";
import TestingPage from "../pages/Testing/TestingPage";

/** Точка входа всех роутов */
function MainRoutes() {

    return (
        <Routes>
            <Route path="/" element={<MapScreen />} />
            <Route path="/testing" element={<TestingPage />} />
        </Routes>
    )
}

export default MainRoutes;